/**
* Products - Show
*/
(function ($) {
  $(document).on('turbolinks:load', () => {
    // Only run this on `.products.show` page.
    if (!document.querySelector('.products.show')) {
      return
    }
  })
}(jQuery))
